import React from 'react'
import { Helmet } from 'react-helmet'

const MetaData = ({
  pageTitle,
  pageDescription,
  canonicalLink,
  socialTagsData,
  schemaData
}) => (
  <Helmet>
    {pageTitle && <title>{pageTitle}</title>}
    {pageDescription && (
      <meta
        name="description"
        content={pageDescription}
      />
    )}
    {canonicalLink && (
      <link
        rel="canonical"
        href={canonicalLink}
      />
    )}
    {socialTagsData &&
      socialTagsData.map((tag) => (
        <meta
          key={tag.name || tag.property}
          {...tag}
        />
      ))}
    {schemaData && (
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
    )}
  </Helmet>
)

export default MetaData
